
import React, { useEffect, useState,useRef } from "react";

const TableOfContents = (props) => {



  //PARAMETERS
  // Tags = "h2, h2a"    - allows assignment of other tags instead of just h2, and h2a
  // Lowercase = false  - if true, transforms the text to lowercase, then CSS will transform to Titlecase
  const headingTags = props?.Tags?.toLowerCase().replace(/ /g, '').split(',') ?? ["h2", "h2a"]
   
      const useHeadingsData = () => {
        const [nestedHeadings, setNestedHeadings] = useState([]);
      
        useEffect(() => {
          const headingElements = Array.from(
            document.querySelectorAll(headingTags.join(", "))
          );
      
          const newNestedHeadings = getNestedHeadings(headingElements);
          setNestedHeadings(newNestedHeadings);
        }, []);
      
        return { nestedHeadings };
      };

      const getNestedHeadings = (headingElements) => {
        const nestedHeadings = [];
      
        headingElements.forEach((heading, index) => {
          const { innerText: title, id } = heading;
          if (heading.nodeName === headingTags[0].toUpperCase()) {
            nestedHeadings.push({ id, title, items: [] });
          } 
          else if (heading.nodeName === headingTags[1].toUpperCase() && nestedHeadings.length > 0) {
            nestedHeadings[nestedHeadings.length - 1].items.push({
              id,
              title,
            });
          }
        });
      
        return nestedHeadings;
      };

      const Headings = ({ headings, activeId }) => (
        <>
          {headings.map((heading) => (
            <>
              <a key={heading.id}
                className={heading.id === activeId ? "active" : ""}
                href={`#${heading.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector(`#${heading.id}`).scrollIntoView({
                     behavior: "smooth"
                  });
                }}
              >
                {props.Lowercase===true
                  ? heading.title.toLowerCase()
                  : heading.title
                }
              </a>

                {heading.items.length > 0 && (
                <>
                {heading.items.map((child) => (
                      <a key={child.id} className={'sub '+ (child.id === activeId ? "active" : "")}
                        href={`#${child.id}`}
                        onClick={(e) => {
                          e.preventDefault();
                          document.querySelector(`#${child.id}`).scrollIntoView({
                            behavior: "smooth"
                          });
                        }}
                      >
                        {props.Lowercase===true 
                          ? child.title.toLowerCase()
                          : child.title
                        }
                      </a>
                  ))}  
                  </>
              )}
          </>
          ))}
        </>
      );

    const [activeId, setActiveId] = useState();
    const { nestedHeadings } = useHeadingsData();
    //useIntersectionObserver(setActiveId);
  
    return (
      <>
      <nav aria-label="Table of contents" >
        <Headings headings={nestedHeadings} activeId={activeId} />
      </nav>
      </>
    );
  };

export default TableOfContents;